"use client";

import { useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const CS = () => {
  const { translations, currentLang } = useLanguage();
  const t = translations[currentLang];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      alert(
        currentLang === "KOR"
          ? "필수 항목을 모두 입력해주세요."
          : "Please fill in all required fields."
      );
      return;
    }

    try {
      setLoading(true);
      const response = await fetch("/api/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        alert(
          currentLang === "KOR"
            ? result.message
            : "Your inquiry has been successfully submitted. We will respond as soon as possible."
        );
        setFormData({ name: "", email: "", company: "", message: "" });
      } else {
        alert(
          currentLang === "KOR"
            ? result.message
            : "Failed to submit inquiry. Please try again."
        );
      }
    } catch (error) {
      console.error("Error sending email:", error);
      alert(
        currentLang === "KOR"
          ? "문의 전송 중 오류가 발생했습니다. 다시 시도해주세요."
          : "An error occurred while submitting your inquiry. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <section
      className="min-h-screen py-24 px-4 md:px-12 flex flex-col justify-center items-center relative bg-black bg-opacity-80"
      style={{
        backgroundImage: "url('/assets/aiart4.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="absolute inset-0 bg-[rgba(0,0,0,0.5)] z-10"></div>

      <div className="relative z-20 max-w-4xl text-center flex flex-col items-center">
        <h2 className="text-4xl md:text-6xl lg:text-7xl mb-8 text-[#00c4ff] font-bold">
          {t.supportTitle}
        </h2>

        <p className="text-lg md:text-xl opacity-90 mb-12 font-medium">
          {t.supportDesc}
        </p>

        <div className="bg-[rgba(255,255,255,0.1)] p-8 rounded-2xl backdrop-blur-sm max-w-2xl w-full">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="text-left">
              <label
                htmlFor="name"
                className="block mb-2 text-[#00c4ff] font-bold"
              >
                {t.formNameLabel}
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full p-3 border-2 border-[rgba(0,196,255,0.3)] rounded-lg bg-[rgba(0,0,0,.5)] bg-opacity-50 text-white text-base focus:outline-none focus:border-[#00c4ff]"
              />
            </div>

            <div className="text-left">
              <label
                htmlFor="email"
                className="block mb-2 text-[#00c4ff] font-bold"
              >
                {t.formEmailLabel}
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full p-3 border-2 border-[rgba(0,196,255,0.3)] rounded-lg bg-[rgba(0,0,0,.5)] bg-opacity-50 text-white text-base focus:outline-none focus:border-[#00c4ff]"
              />
            </div>

            <div className="text-left">
              <label
                htmlFor="company"
                className="block mb-2 text-[#00c4ff] font-bold"
              >
                {t.formCompanyLabel}
              </label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                className="w-full p-3 border-2 border-[rgba(0,196,255,0.3)] rounded-lg bg-[rgba(0,0,0,.5)] bg-opacity-50 text-white text-base focus:outline-none focus:border-[#00c4ff]"
              />
            </div>

            <div className="text-left">
              <label
                htmlFor="message"
                className="block mb-2 text-[#00c4ff] font-bold"
              >
                {t.formMessageLabel}
              </label>
              <textarea
                id="message"
                name="message"
                rows={5}
                value={formData.message}
                onChange={handleChange}
                required
                className="w-full p-3 border-2 border-[rgba(0,196,255,0.3)] rounded-lg bg-[rgba(0,0,0,.5)] bg-opacity-50 text-white text-base focus:outline-none focus:border-[#00c4ff] resize-vertical"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-[#00c4ff] to-[#0080cc] text-white border-none py-4 rounded-lg text-lg font-bold cursor-pointer transition-transform duration-300 hover:-translate-y-1 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading
                ? currentLang === "KOR"
                  ? "전송 중..."
                  : "Sending..."
                : t.submitBtn}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default CS;
